import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a security cam icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <SecurityCamIcon width={24} />
 */
const SecurityCamIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M18.63 15.9201L18.38 16.4601C18.15 16.9601 17.56 17.1501 17.08 16.8901L5.65 10.7001C5.17
            10.4401 4.95 9.81012 5.17 9.31012L6.78 5.63012C7 5.13012 7.6 4.87012 8.12 5.07012L20.4
            9.74012C20.91 9.94012 21.15 10.5001 20.91 11.0001L20.45 12.0001H19C18.45 12.0001 18 12.4501
            18 13.0001V15.0001C18 15.4201 18.26 15.7801 18.63 15.9201ZM11.78 14.8101L10.02 13.8601C9.54
            13.6001 8.93 13.7801 8.66 14.2601L8.5 14.5701C8.43 14.7101 8.4 14.8501 8.39 15.0001H6V14.0001C6
            13.4501 5.55 13.0001 5 13.0001H4C3.45 13.0001 3 13.4501 3 14.0001V18.0001C3 18.5501 3.45
            19.0001 4 19.0001H5C5.55 19.0001 6 18.5501 6 18.0001V17.0001H11C10.99 17.0001 11.01 17.0001
            11 17.0001C11.4 17.0001 11.82 16.8401 12.01 16.4801L12.18 16.1701C12.44 15.6801 12.26 15.0701
            11.78 14.8101Z`}
        />
    </SvgIcon>
)

SecurityCamIcon.defaultProps = defaultProps

export { SecurityCamIcon }
